import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { onMount } from 'svelte';
import { getAppInfo } from '$lib/api/info';

var root_1 = $.from_html(`<footer class="mt-8 py-4 text-center text-xs text-muted-foreground"> </footer>`);

export default function Footer($$anchor, $$props) {
	$.push($$props, true);

	let appInfo = $.state(null);

	onMount(async () => {
		try {
			$.set(appInfo, await getAppInfo(), true);
		} catch {
			// Footer info is non-critical — silently ignore failures
		}
	});

	var fragment = $.comment();
	var node = $.first_child(fragment);

	{
		var consequent = ($$anchor) => {
			var footer = root_1();
			var text = $.child(footer, true);

			$.reset(footer);
			$.template_effect(($0) => $.set_text(text, $0), [() => $.get(appInfo).commit.slice(0, 7)]);
			$.append($$anchor, footer);
		};

		$.if(node, ($$render) => {
			if ($.get(appInfo)) $$render(consequent);
		});
	}

	$.append($$anchor, fragment);
	$.pop();
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiRm9vdGVyLnN2ZWx0ZSJdLCJzb3VyY2VzQ29udGVudCI6WyI8c2NyaXB0IGxhbmc9XCJ0c1wiPlxuICBpbXBvcnQgeyBvbk1vdW50IH0gZnJvbSAnc3ZlbHRlJztcbiAgaW1wb3J0IHsgZ2V0QXBwSW5mbywgdHlwZSBBcHBJbmZvIH0gZnJvbSAnJGxpYi9hcGkvaW5mbyc7XG5cbiAgbGV0IGFwcEluZm8gPSAkc3RhdGU8QXBwSW5mbyB8IG51bGw+KG51bGwpO1xuXG4gIG9uTW91bnQoYXN5bmMgKCkgPT4ge1xuICAgIHRyeSB7XG4gICAgICBhcHBJbmZvID0gYXdhaXQgZ2V0QXBwSW5mbygpO1xuICAgIH0gY2F0Y2gge1xuICAgICAgLy8gRm9vdGVyIGluZm8gaXMgbm9uLWNyaXRpY2FsIOKAlCBzaWxlbnRseSBpZ25vcmUgZmFpbHVyZXNcbiAgICB9XG4gIH0pO1xuPC9zY3JpcHQ+XG5cbnsjaWYgYXBwSW5mb31cbiAgPGZvb3RlciBjbGFzcz1cIm10LTggcHktNCB0ZXh0LWNlbnRlciB0ZXh0LXhzIHRleHQtbXV0ZWQtZm9yZWdyb3VuZFwiPlxuICAgIHthcHBJbmZvLmNvbW1pdC5zbGljZSgwLCA3KX1cbiAgPC9mb290ZXI+XG57L2lmfSJdLCJtYXBwaW5ncyI6Ijs7U0FDVyxPQUFPLFFBQVEsUUFBUTtTQUN2QixVQUFVLFFBQXNCLGVBQWU7Ozs7a0RBRjFELENBQUM7OztLQUlLLE9BQU8sV0FBMEIsSUFBSTs7Q0FFekMsT0FBTyxhQUFhLENBQUM7TUFDZixDQUFDO1NBQ0gsT0FBTyxRQUFTLFVBQVU7RUFDNUIsQ0FBQyxPQUFPLENBQUM7O0VBRVQsQ0FBQztDQUNILENBQUM7Ozs7Ozs7Ozs7O2dFQUtFLE9BQU8sRUFBQyxNQUFNLENBQUMsS0FBSyxDQUFDLENBQUMsRUFBRSxDQUFDOzs7OzthQUZ6QixPQUFPOzs7Ozs7QUFGYixDQUFDIn0=